import { render, staticRenderFns } from "./ReactivationOverall.vue?vue&type=template&id=ed95c22e&"
import script from "./ReactivationOverall.vue?vue&type=script&lang=ts&"
export * from "./ReactivationOverall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports